import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function AddPreferredCollectionDate(i: SmartSendItemApiModel) {
  if (!i.PreferredCollectionDate && i.State?.validation?.QuoteState?.Dates?.length) {
    i.PreferredCollectionDate = i.State?.validation?.QuoteState?.Dates[0].Date;
  }
}
